import React, { useState, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './ArticleWrite.module.scss';
import formStyles from '../../common/ui/Form.module.scss';
import spinner from '../../common/ui/Spinner.module.scss';
import qs from 'query-string';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import useFetch from '../../common/hooks/useFetch';

const ArticleWrite = (props) => {

  const location = useLocation();
  const params = qs.parse(location.search);
  const navigate = useNavigate();

  const [title, setTitle] = useState();
  const [content, setContent] = useState();

  const [parentCategories, setParentCategories] = useState([]);
  const [childCategories, setChildCategories] = useState([]);

  const [parentIndex, setParentIndex] = useState('0');
  const [childIndex, setChildIndex] = useState('0');

  const parentBoard = useRef();
  const childBoard = useRef();

  const [initArticle, setInitArticle] = useState();
  const [isInit, setIsInit] = useState(false);
  
  const [isFetching, setIsFetching] = useState();
  const [isLogin, profile] = useSelector(state => [state.profileReducer.isLogin, state.profileReducer.profile]);

  useEffect(() => {
    const parentId = initParentCategories(params.boardId);
    initChildCategories(parentId, parseInt(params.boardId) === parentId ? null : params.boardId);

    if (params.command === 'write'){
      setIsInit(true);
    }
    else{
      const urlContent = '/api/board/view' + location.search;
      axios.get(urlContent, {"Content-Type": 'application/json'})
      .then((res) => {
        if (res.data.code === 410){
          setInitArticle(res.data.article);
          setTitle(res.data.article.title);
          setContent(res.data.article.content);
        }
        else{
          alert('오류가 발생하였습니다.');
        }
      })
      .catch((err) => {
        alert('오류가 발생하였습니다.');
      })
      .finally(() => {
        setIsInit(true);
      });
    }
  }, []);

  // Init
  //////////////////////////////////////////////////////
  const initParentCategories = (value) => {
    const currentBoard = value ? props.categoriesDic[value] : null;
    let parentIndex = 0;

    const temp = [];
    props.categories.forEach((x, idx) => {

      if (currentBoard?.parentId) {
        if (currentBoard.parentId === x.id) {
          parentIndex = idx;
        }
      }
      else if (currentBoard?.id === x.id) {
        parentIndex = idx;
      }

      temp.push({
        id: x.id,
        title: x.title
      });
    });

    setParentCategories(temp);
    setParentIndex(parentIndex.toString());
    parentBoard.current = temp.length > 0 ? temp[parentIndex] : null;

    return temp[parentIndex].id;
  }

  const initChildCategories = (parentBoardId, childBoardId) => {
    const parent = (props.categories.filter(x=>x.id === parentBoardId))[0];
    const child = childBoardId ? props.categoriesDic[childBoardId] : null;
    let childIndex = 0;

    const temp = [];
    if (parent.childCount > 0) {
      parent.children.map((x, index) => {
        if (child?.id === x.id) {
          childIndex = index;
        }
        temp.push({
          id: x.id,
          title: x.title
        });
      })
    }

    setChildCategories(temp);
    setChildIndex(childIndex.toString());
    childBoard.current = temp.length > 0 ? temp[childIndex] : null;
  }

  const getPath = () => {
    let temp = props.title;
    if (params.boardId) {
      const board = props.categoriesDic[params.boardId];
      if (board.parentId) {
        temp += ` / ${props.categoriesDic[board.parentId].title}`;
      }
      temp += ` / ${board.title}`;
    }

    return temp;
  }

  // Handle Change
  /////////////////////////////////////////////////////
  const handleParentCategoriesChange = (e) => {
    setParentIndex(e.target.value);
    parentBoard.current = parentCategories[e.target.value];

    initChildCategories(parentCategories[e.target.value].id, null);
  }

  const handleChildCategoriesChange = (e) => {
    setChildIndex(e.target.value);
    childBoard.current = childCategories[e.target.value];
  }

  const handleChange = (e) => {
    if (e.target.name === 'title') {
      setTitle(e.target.value);
    }
    else if (e.target.name === 'content') {
      setContent(e.target.value);
    }
  }


  // Fetch
  /////////////////////////////////////////////////////
  const writeArticle = () => {
    if (!title) {
      alert('제목을 입력해주세요.');
      return;
    }

    setIsFetching(true);

    setTimeout(() => {
    const newParams = {};
    newParams.rootCategory = params.rootCategory;
    newParams.boardId = childBoard.current ? childBoard.current.id : parentBoard.current.id;
    newParams.parentBoardId = parentBoard.current.id;
    newParams.articleId = initArticle?.id;
    newParams.command = params.command;

    axios.post('/api/board/write?' + qs.stringify(newParams), {
      title: title,
      content: content,
      writerId: profile.id,
      writerNickname: profile.nickname
    }).then((res) => {
      if (res.data.code === 420) {
        const goParams = {
          ...params,
          command: 'view',
          boardId: res.data.boardId,
          articleId: res.data.articleId,
          fromRoot : params.fromRoot
        };
        navigate(location.pathname + '?' + qs.stringify(goParams));
      }
      else {
        alert('오류가 발생하였습니다.');
      }

      setIsFetching(false);
    });
    }, 100);
  }

  if (!isInit){
    return '';
  }

  return (
    <div id={styles.wrapper_articleWrite}>
      <div id={styles.header}>
        <p className={styles.header_title}>게시글 작성</p>
        <p className={styles.path}>{getPath()}</p>
      </div>

      <div id={styles.body}>
        <div className={styles.category_container}>
          {parentCategories.length > 0 ?
            <select value={parentIndex} onChange={handleParentCategoriesChange}>
              {parentCategories.map((x, index) => {
                return <option key={index} value={index.toString()}>{x.title}</option>
              })}
            </select> :
            <select disabled>
            </select>
          }
          {
            childCategories.length > 0 ?
              <select value={childIndex} onChange={handleChildCategoriesChange}>
                {childCategories.map((x, index) => {
                  return <option key={index} value={index.toString()}>{x.title}</option>
                })}
              </select> :
              <select disabled>
              </select>
          }

        </div>
        <input className={styles.title} name='title' onChange={handleChange} placeholder='제목을 입력해주세요' value={title || ''} />
        <textarea className={styles.content} name='content' onChange={handleChange} value={content || ''}
          placeholder='내용을 입력하세요.'
        />
      </div>
      <div id={styles.footer}>
        {isFetching ?
          <div className={spinner.spinner} style={{ position: 'absolute', right: '17px' }} /> :
          <button className={formStyles.button} onClick={writeArticle}><p>작성하기</p></button>
        }
      </div>
    </div>
  )
}

export default ArticleWrite